import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '@web/modules/campaigns/templates/templates-page';

export const Route = createFileRoute('/_app/campaigns/templates')({
  component: TemplatesPage,
});
